import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { api, call } from "@/core/api/client";
import { ENDPOINTS } from "@/core/api/endpoints";
import { QUERY_KEYS } from "@/core/api/query-client";
import type { components } from "@/core/api/schema";

export type AnalyticsSummary = components["schemas"]["AnalyticsSummary"];
export type AnalyticsPlan = components["schemas"]["AnalyticsPlan"];
export type SignupRange = AnalyticsSummary["signups"]["range"];
export type RevenuePeriod = AnalyticsSummary["period"]["period"];

const scope = (brandId: string) => (brandId ? { brandId } : {});

/** Every brand's numbers (brandId ""), or one brand's: KPIs, retention, the new-subscriptions chart. */
export function useAnalyticsSummary(brandId: string, range: SignupRange, period: RevenuePeriod = "all") {
  return useQuery({
    queryKey: [...QUERY_KEYS.analytics.summary(brandId, range), period],
    queryFn: async () =>
      (
        await call(
          api.GET(ENDPOINTS.adminAnalyticsSummary, {
            params: { query: { range, period, ...scope(brandId) } },
          }),
        )
      ).data,
    placeholderData: keepPreviousData,
  });
}

/** Plans across brands (or one brand's): subscribers, sales, revenue, churn. */
export function useAnalyticsPlans(brandId: string) {
  return useQuery({
    queryKey: QUERY_KEYS.analytics.plans(brandId),
    queryFn: async () =>
      (await call(api.GET(ENDPOINTS.adminAnalyticsPlans, { params: { query: scope(brandId) } }))).data,
    placeholderData: keepPreviousData,
  });
}
